<template>
  <a
    class="external-link"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot />

    <icon class="icon" name="launch" />
  </a>
</template>

<script>
import Icon from './Icon';

export default {
  components: {
    Icon,
  },

  props: {
    href: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.external-link {
  cursor: pointer;
  margin-right: $gp * .25;
  font-weight: bold;
  font-size: 14px;
  color: var(--theme-color);

  .icon {
    margin-left: $gp * .25;
    font-size: var(--external-link-icon-size, 16px);
    position: relative;
    top: 2px;
  }
}
</style>
